<template>
  <el-input
    type="password"
    maxlength="6"
    auto-complete="new-password"
    :placeholder="placeholder || 'account password'"
    :value="value"
    @input="handleInput"
    @change="$emit('change', $event)"
    v-bind="$attrs"
  />
</template>
<script>
export default {
  name: 'AccountPasswordInput',
  props: ['value', 'placeholder'],
  methods: {
    handleInput(val) {
      const newVal = val.replace(/\D/g, '').substring(0, 6)
      this.$emit('input', newVal)
    }
  }
}
</script>
<style lang="scss"></style>
